import { PageContainer } from 'components/PageContainer/PageContainer';
import React from 'react';

export const AuditPage = () => {
  return (
    <PageContainer>
      <div>
      TODO : AUDIT PAGE
      </div>
    </PageContainer>
  )
}